// extracted by mini-css-extract-plugin
export default {"opaqueGroupGiftRegItemCard":"group-gift-reg-item-card__opaqueGroupGiftRegItemCard__CrFvW","fundingProgress":"group-gift-reg-item-card__fundingProgress__GNez2"};